/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MatchedAllergyDto } from './matchedAllergyDto';


export interface ExposureCheckResultDto { 
    /**
     * Alert level based on matched allergies
     */
    alertLevel: ExposureCheckResultDto.AlertLevelEnum;
    /**
     * Whether any allergen exposure was detected
     */
    hasExposure: boolean;
    /**
     * Human-readable summary message
     */
    message: string;
    /**
     * List of matched allergies
     */
    matchedAllergies: Array<MatchedAllergyDto>;
    /**
     * Alternative substance suggestions (if available)
     */
    alternativeSuggestions: Array<string>;
    /**
     * Clinical guidance for handling the exposure
     */
    clinicalGuidance?: string;
    /**
     * Element IDs that were checked
     */
    checkedSubstances: Array<string>;
    /**
     * Response time in milliseconds
     */
    responseTime: number;
}
export namespace ExposureCheckResultDto {
    export type AlertLevelEnum = 'clear' | 'info' | 'warning' | 'hard_stop';
    export const AlertLevelEnum = {
        Clear: 'clear' as AlertLevelEnum,
        Info: 'info' as AlertLevelEnum,
        Warning: 'warning' as AlertLevelEnum,
        HardStop: 'hard_stop' as AlertLevelEnum
    };
}


